export const LIBRARY_SECTION = {
    IMPORT: "import",
    IMAGINE: "imagine",
    VEEVA: "veeva"
} as const;

export type LibrarySection = (typeof LIBRARY_SECTION)[keyof typeof LIBRARY_SECTION];
